import axios from "../axios";
import h from "../helpers";
import { clientIp } from "../api-address";

const stockMovement = {
  index: async (params) => {
    const { data } = await axios.get(h.baseUrl("stock-movement"), {
      params: { ...params },
    });
    return data;
  },
  show: async (id) => {
    const { data } = await axios.get(h.baseUrl("stock-movement/" + id));
    return data;
  },
  store: async (
    code,
    code_list,
    product_name,
    product_variant_id,
    warehouse_id,
    physical_stock,
    opname_date,
    description,
    status,
  ) => {
    const { data } = await axios.post(h.baseUrl("stock-movement"), {
      code,
      code_list,
      product_name,
      product_variant_id,
      warehouse_id,
      physical_stock,
      opname_date,
      description,
      status,
      ip_address: await clientIp(),
    });
    return data;
  },
  update: async (
    id,
    name,
    code,
    variant_id,
    supplier_id,
    price,
    weight,
    imageUrl
  ) => {
    const { data } = await axios.put(h.baseUrl("stock-movement/" + id), {
      name,
      code,
      variant_id,
      supplier_id,
      price,
      weight,
      imageUrl,
      ip_address: await clientIp(),
    });
    return data;
  },
  delete: async (id) => {
    const ip = await clientIp();
    const { data } = await axios.delete(
      h.baseUrl("stock-movement/" + id + `?ip_address=${ip}`)
    );
    return data;
  },
};

export default stockMovement;
